import React from "react";
import "./styles.scss";
import { useSelector } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import hv_player_api from "../../../../../api/hv_player_api";
import PlayButton from "../../../../shared/Svg/PlayButton";
import Pause from "../../../../shared/Svg/Pause";
import defaultAlbumImg from '../../../../../public/images/default-alblum-img.png';

export default ({ medium, source = null }) => {
  const controls = useSelector((state) => state);
  const playMedium = () =>
    source
      ? hv_player_api.playMediaWithSource(medium, source)
      : hv_player_api.playMediaWithoutSource(medium);

  const title = medium.title;
  const username = medium.user ? medium.user.username : "Unknown";

  return (
    <>
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip>{title || username}</Tooltip>}
      >
        <div className="card-body position-relative">
          <img
            src={
              medium.preview_image ? medium.preview_image.url : defaultAlbumImg
            }
            alt={title}
          />

          <div className="position-absolute controls">
            {controls.currently_playing.id === medium.id ? (
              controls.currently_playing.status === "ready" ? (
                controls.playing ? (
                  /*
                  <p
                    className="pause-icon font-weight-bold text-white mr-2"
                    onClick={hv_player_api.pause}
                  >
                    Pause
                  </p>*/
                  <Pause className="pause-button" onClick={hv_player_api.pause} />
                ) : (
                  <PlayButton
                    className="play-button"
                    onClick={hv_player_api.play}
                  />
                )
              ) : (
                <Spinner
                  animation="border"
                  variant="primary"
                  size="sm"
                  role="status"
                />
              )
            ) : (
              <PlayButton className="play-button" onClick={playMedium} />
            )}
          </div>
        </div>
      </OverlayTrigger>
      <div className="card-footer py-2">
        <OverlayTrigger placement="bottom" overlay={<Tooltip>{title}</Tooltip>}>
          <p className="text-dark text-uppercase song-title overflow-item text-left">
            {title}
          </p>
        </OverlayTrigger>
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip>{username}</Tooltip>}
        >
          <p className="text-muted artist-name overflow-item text-left">
            {username}
          </p>
        </OverlayTrigger>
      </div>
    </>
  );
};
